import * as React from "react";

function SvgPixelMe(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 83 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        fill="#2E89E2"
        d="M5 61h20v20H5zM33 61h20v20H33zM61 61h20v20H61zM5 33h20v20H5zM33 33h20v20H33zM61 33h20v20H61z"
      />
      <path fill="#14191C" d="M15 .858L29.142 15 15 29.142.858 15z" />
      <path fill="#2E89E2" d="M33 5h20v20H33zM61 5h20v20H61z" />
    </svg>
  );
}

export default React.forwardRef(SvgPixelMe);
